import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsOptional } from 'class-validator'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { FieldSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/fields/dtos/requests/FieldSearchRequestDTO'

export class FieldFiltersFormModel extends FormModel {

    @IsOptional()
    searchString?: number

    constructor(initialData?: Partial<FieldFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

    /**
     */
    static formatDto(formStateManager: IFormStateManager<FieldFiltersFormModel>): FieldSearchRequestDTO {

        if (!formStateManager.getFormValues())
            return {}

        const formValues = formStateManager.getFormValues()!
        return {
            searchString: formValues.searchString
        }
    }

}
